var e=(e,t)=>{if(!e)return"-";const r=e.split("");return t.reduce((e,t)=>"object"==typeof t?e+r.shift():e+t,"")};export{e as getMaskedValue};
//# sourceMappingURL=getMaskedValue.js.map